import {Plan} from '../types/Plan';
import {ChartPrubeh, EnumPlanObdobi, StromApi} from '../api';
import {MEZIROCNI_PRUBEH, MEZIROCNI_SROVNANI, PODPOLOZKY} from '../enums/ChartTypeEnum';
import {LineChartData} from '../types/LineChartData';
import {PRUBEH} from '../enums/PohledTypeEnum';
import {getMonth} from '../utils/NumberUtils';
import React, {useEffect, useState} from 'react';
import {DonutChartData} from '../types/DonutChartData';
import {DonutChart} from './DonutChart';
import {LineChart} from './LineChart';
import {Spinner} from 'react-bootstrap';

interface BaseChartProps {
    chartType: string;
    plans: Plan[];
    selectedPlan: Plan;
    planObdobi: EnumPlanObdobi;
    idVerze: string;
}

export const BaseChart: React.FC<BaseChartProps> = ({chartType, plans, selectedPlan, planObdobi, idVerze}) => {
    const [lineData, setLineData] = useState<LineChartData[]>([]);
    const [donutData, setDonutData] = useState<DonutChartData[]>([]);
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        loadChartData();
    }, [chartType, selectedPlan, planObdobi]);

    const loadChartData = async () => {
        setFetching(true);
        let loadedData;
        switch (chartType) {
            case PODPOLOZKY:
                loadedData = plans
                    .filter(item => item.idPlanOt == selectedPlan.idPlan)
                    .map(item => {
                        const value = planObdobi === EnumPlanObdobi.SKUTECNOST ? item.skutecnnost : item.upravenyRozpocet;
                        return {
                            value: value === undefined ? 0 : Math.abs(value) / 1000,
                            type: item.nazevAkce,
                            idPlan: item.idPlan,
                        };
                    });
                setDonutData(loadedData);
                setFetching(false);
                break;

            case MEZIROCNI_SROVNANI:
                loadedData = (await StromApi.getMezirocniSrovnani(selectedPlan.idObjekt, planObdobi)).data;
                const srovnaniData: LineChartData[] = [];
                for (let key in loadedData) {
                    const plan = loadedData[key];
                    srovnaniData.push({value: plan.skutecnnost, dataType: 'Skutečnost', timestamp: key});
                    srovnaniData.push({
                        value: plan.upravenyRozpocet,
                        dataType: 'Upravený rozpočet',
                        timestamp: key,
                    });
                    srovnaniData.push({
                        value: plan.schvalenyRozpocet,
                        dataType: 'Schválený rozpočet',
                        timestamp: key,
                    });
                }
                setLineData(srovnaniData);
                setFetching(false);
                break;

            case PRUBEH:
                loadedData = (await StromApi.getPrubehData(selectedPlan.idPlan)).data;
                const prubehData: LineChartData[] = [];
                loadedData.forEach(item => {
                    prubehData.push({
                        value: item.skutecnnost,
                        dataType: 'Skutečnost',
                        timestamp: getMonth(item.mesic),
                    });
                    prubehData.push({
                        value: item.upravenyRozpocet,
                        dataType: 'Upravený rozpočet',
                        timestamp: getMonth(item.mesic),
                    });
                    prubehData.push({
                        value: item.schvalenyRozpocet,
                        dataType: 'Schválený rozpočet',
                        timestamp: getMonth(item.mesic),
                    });
                });

                setLineData(prubehData);
                setFetching(false);
                break;

            case MEZIROCNI_PRUBEH:
                loadedData = (await StromApi.getMezirocniPrubeh(selectedPlan.idObjekt, selectedPlan.idPlan, planObdobi)).data;
                const mezPrubeh: LineChartData[] = [];
                for (let key in loadedData) {
                    const prubeh: ChartPrubeh[] = loadedData[key];
                    prubeh.forEach(item => {
                        mezPrubeh.push({value: item.castka, dataType: key, timestamp: getMonth(item.mesic)});
                    });
                }
                setLineData(mezPrubeh);
                setFetching(false);
                break;
        }
    };

    if (fetching) {
        return (
            <div className="loading-data" style={{marginTop: '10vh'}}>
                <Spinner animation="border" role="status" style={{marginRight: 10}} />
                Načítání dat...
            </div>
        );
    }

    return (
        <div>
            {chartType === PODPOLOZKY ? (
                <DonutChart title={selectedPlan.nazevAkce} idVerze={idVerze} data={donutData} />
            ) : (
                <LineChart title={selectedPlan.nazevAkce} data={lineData} />
            )}
        </div>
    );
};
